import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/pages/homepage.css';

const HomePage = () => {
  const { t, isRTL } = useLanguage();
  const navigate = useNavigate();
  
  const handleChatClick = () => {
    navigate('/disc');
  };
  
  const handleServicesClick = () => {
    navigate('/services');
  };

  const handleMemorandumClick = () => {
    navigate('/chat');
  };

  // ✅ NEW: Pleadings card handler
  const handlePleadingsClick = () => {
    navigate('/pleadings');
  };
  
  return (
    <div className={`yimnak-homepage ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className="yimnak-homepage-hero-section">
        <div className="yimnak-homepage-hero-content">
          <h1>{t('welcomeTitle')}</h1>
          <p>{t('welcomeSubtitle')}</p>

          <div className="yimnak-homepage-hero-features">
            
            {/* الدردشة المباشرة */}
            <div
              className="yimnak-homepage-feature clickable"
              onClick={handleChatClick}
            >
              <h3>{t('realTimeChat')}</h3>
              <p>{t('realTimeChatDesc')}</p>
            </div>

            {/* خدماتنا */}
            <div
              className="yimnak-homepage-feature clickable"
              onClick={handleServicesClick}
            >
              <h3>{t('ourServices')}</h3>
              <p>{t('ourServicesDesc')}</p>
            </div>

            {/* إعداد المذكرات */}
            <div
              className="yimnak-homepage-feature clickable"
              onClick={handleMemorandumClick}
            >
              <h3>{t('analytics')}</h3>
              <p>{t('analyticsDesc')}</p>
            </div>

            {/* ✅ NEW: المرافعات القضائية */}
            <div
              className="yimnak-homepage-feature clickable"
              onClick={handlePleadingsClick}
            >
              <h3>{t('pleadings')}</h3>
              <p>{t('pleadingsDesc')}</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
